import { render } from "./ListItemServico.vue?vue&type=template&id=5c758b6c&scoped=true"
import script from "./ListItemServico.vue?vue&type=script&lang=js"
export * from "./ListItemServico.vue?vue&type=script&lang=js"

import "./ListItemServico.vue?vue&type=style&index=0&id=5c758b6c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c758b6c"]])

export default __exports__